/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './sample-container-type.reducer';

export const SampleContainerTypeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const sampleContainerTypeEntity = useAppSelector(state => state.sampleContainerType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="sampleContainerTypeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.sampleContainerType.detail.title">SampleContainerType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.sampleContainerType.id">Id</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTypeEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.sampleContainerType.active">Active</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTypeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.sampleContainerType.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTypeEntity.lastUpdated}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.sampleContainerType.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTypeEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.sampleContainerType.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTypeEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.sampleContainerType.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTypeEntity.cursor}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.sampleContainerType.code">Code</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTypeEntity.code}</dd>
          <dt>
            <span id="color">
              <Translate contentKey="tinyMedicRestApp.sampleContainerType.color">Color</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTypeEntity.color}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.sampleContainerType.description">Description</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTypeEntity.description}</dd>
          <dt>
            <span id="unitsOfMeasure">
              <Translate contentKey="tinyMedicRestApp.sampleContainerType.unitsOfMeasure">Units Of Measure</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTypeEntity.unitsOfMeasure}</dd>
          <dt>
            <span id="tmSize">
              <Translate contentKey="tinyMedicRestApp.sampleContainerType.tmSize">Tm Size</Translate>
            </span>
          </dt>
          <dd>{sampleContainerTypeEntity.tmSize}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.sampleContainerType.lab">Lab</Translate>
          </dt>
          <dd>{sampleContainerTypeEntity.lab ? sampleContainerTypeEntity.lab.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/sample-container-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/sample-container-type/${sampleContainerTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SampleContainerTypeDetail;
